import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _InfoRoundFill(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0m-8-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0m0 9v-6h-2v6z", clipRule: "evenodd" })));
}
const InfoRoundFill = forwardRef(_InfoRoundFill);
export { InfoRoundFill };
